// for add club venue
export const LOGGED_IN_USER_Info = "logged_in_user_info";
export const LOGGED_IN_USER_INFO_SUCCESS = "logged_in_user_info_success";
export const LOGGED_IN_USER_INFO_FAILURE = "logged_in_user_info_failure";
